import { render, staticRenderFns } from "./AddMediaForClassDialog.vue?vue&type=template&id=b9ca4c2e&scoped=true"
import script from "./AddMediaForClassDialog.vue?vue&type=script&lang=js"
export * from "./AddMediaForClassDialog.vue?vue&type=script&lang=js"
import style0 from "./AddMediaForClassDialog.vue?vue&type=style&index=0&id=b9ca4c2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ca4c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9ca4c2e')) {
      api.createRecord('b9ca4c2e', component.options)
    } else {
      api.reload('b9ca4c2e', component.options)
    }
    module.hot.accept("./AddMediaForClassDialog.vue?vue&type=template&id=b9ca4c2e&scoped=true", function () {
      api.rerender('b9ca4c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/AddMediaForClassDialog.vue"
export default component.exports